export default __webpack_public_path__ + "static/media/README.31425f8f.md";